module.exports = __webpack_public_path__ + "img/VG.ea35ce59.svg";